import request from '@/utils/request'

// 获取告警历史记录
export function getAlarmHistory(params) {
  return request({
    url: '/api/v1/alarms/log',
    method: 'get',
    params
  })
}

// 处理告警 (设置为已解决/已忽略)
export function resolveAlarm(id, data) {
  return request({
    url: `/api/v1/alarms/log/${id}/resolve`,
    method: 'put',
    data
  })
}

// 忽略告警
export function ignoreAlarm(id) {
  return request({
    url: `/api/v1/alarms/log/${id}/ignore`,
    method: 'put'
  })
}

// 删除告警历史记录
export function deleteAlarmHistory(id) {
  return request({
    url: `/api/v1/alarms/log/${id}`,
    method: 'delete'
  })
}

// 批量删除告警历史记录
export function batchDeleteAlarmHistory(ids) {
  return request({
    url: '/api/v1/alarms/log/batch',
    method: 'delete',
    data: {
      ids
    }
  })
}

// 导出告警历史
export function exportAlarmHistory(params) {
  return request({
    url: '/api/v1/alarms/log/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
